import { EFFECT_MANIFEST } from './manifest.js';
import { createToneFeedbackDelayEffect } from './factory.js';

export { EFFECT_MANIFEST as TONE_FEEDBACK_DELAY_MANIFEST } from './manifest.js';
export { createToneFeedbackDelayEffect } from './factory.js';

export const toneFeedbackDelayEffectDefinition = {
  id: EFFECT_MANIFEST.id,
  label: EFFECT_MANIFEST.label,
  version: EFFECT_MANIFEST.version,
  inputParam: EFFECT_MANIFEST.inputParam,
  manifest: EFFECT_MANIFEST,
  create: createToneFeedbackDelayEffect,
};

export default toneFeedbackDelayEffectDefinition;
